import { FrontendVariables } from "@Front/Config/VariablesFront";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import type { IBaseApiService } from "@Front/Api/BaseApiServiceFactory";
import { buildIdNotOAuthRedirectUri, readIdNotReturnToFromSessionStorage } from "@Front/Api/Auth/IdNot/helpers/idNotOAuthRedirectUriBrowser";
import { resolveIdNotOAuthPublicBaseUrl } from "@Front/Api/Auth/IdNot/helpers/idNotOAuthPublicBaseUrl";

export function redirectToIdNotLogout(): void {
	const variables = FrontendVariables.getInstance();
	const publicOrigin = resolveIdNotOAuthPublicBaseUrl();
	const callbackUrl = `${publicOrigin}/logout-callback`;
	const logoutUrl = `${variables.IDNOT_BASE_URL}/user/auth/logout?post_logout_redirect_uri=${encodeURIComponent(callbackUrl)}`;

	LoggerService.info("🔄 Redirection vers IdNot logout", {
		logoutUrl,
		callbackUrl,
		note: "IdNot déconnectera l'utilisateur côté serveur et redirigera vers logout-callback",
	});

	window.location.href = logoutUrl;
}

export async function loginWithIdNot(baseApi: IBaseApiService): Promise<unknown> {
	const variables = FrontendVariables.getInstance();
	const redirectUri = buildIdNotOAuthRedirectUri(resolveIdNotOAuthPublicBaseUrl(), readIdNotReturnToFromSessionStorage());
	const url = new URL(
		`${variables.IDNOT_BASE_URL + variables.IDNOT_AUTHORIZE_ENDPOINT}?client_id=${variables.IDNOT_CLIENT_ID}&redirect_uri=${encodeURIComponent(
			redirectUri,
		)}&scope=openid,profile&response_type=code`,
	);
	try {
		return await baseApi.getRequest(url);
	} catch (err) {
		baseApi.onError(err);
		return Promise.reject(err);
	}
}
